import { memo, useRef } from 'react';
import type { SvgIconComponent } from '@mui/icons-material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface Props {
  label?: string;
  error?: boolean;
  isDisabled?: boolean;
  isSecondary?: boolean;
  absoluteLabel?: boolean;
  className?: string;
  icon?: SvgIconComponent;
  value?: string;
  onClick?: () => void;
}

export const LookupInput = memo(({ label, error, isDisabled, isSecondary, absoluteLabel, className, icon: Icon, value, onClick }: Props) => {
  const { t } = useTranslation();

  const variantClass = isSecondary ? 'bg-primary border-1 border-primary-dark' : 'bg-transparent border-1 border-primary-light';

  const buttonRef = useRef<HTMLButtonElement | null>(null);

  return (
    <div
      className={`relative h-max min-h-[3rem] ${className} ${isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
      onClick={() => {
        if (buttonRef.current) {
          buttonRef.current.click();
        }
      }}>
      {label && (
        <label htmlFor={'lookup'} className={`text-sm mb-1 ${absoluteLabel && 'absolute -top-5'}`}>
          {label}
        </label>
      )}

      <div
        className={clsx(
          'flex items-center min-h-[3rem] justify-between h-full px-3 rounded-md focus-within::outline-none focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent',
          error && 'border-red-500',
          isDisabled ? 'bg-gray-200' : variantClass
        )}>
        {value && <p>{value}</p>}
        {!value && <p className="text-sm text-gray-500">{t('common.selectValue')}</p>}
        {Icon && <Icon />}
      </div>
      <button className="hidden " id="lookup" type="button" ref={buttonRef} onClick={!isDisabled ? onClick : undefined} />
    </div>
  );
});
